<template>
	<div>
		<app-header></app-header>
		<div>
            <v-container grid-list-xl mt-5 pt-2>
                <v-layout row justify-center>
                    <v-flex xs12 md10 lg9>
                        <v-card>
                            <v-layout row align-center class="ml-2 mt-2 font-14 fw-400 primary--text">
                                <v-flex xs2 lg2>
                                    {{ $t('userRanking.avatar') }}
                                </v-flex>
                                <v-flex xs3 lg3>
                                    {{ $t('userRanking.nickname') }}
                                </v-flex>
                                <v-flex xs2 lg2>
                                    IOB Power
                                </v-flex>
                                <v-flex xs2 lg2>
                                    IOB Tokens
                                </v-flex>
                                <v-flex xs2 lg2>
                                    RS
                                </v-flex>
                            </v-layout>
                            <template v-for="(user, index) in userInfoList">
                                <v-divider></v-divider>
                                <v-layout row align-center class="ml-2 font-14 fw-400 pointer" @click="gotoUserData(user.userName)">
                                    <v-flex xs2 lg2>
                                        <v-avatar color="primary pointer" size="36">
                                            <img v-show="user.image != null" :src="user.image" :alt="user.userName">
                                            <span v-show="user.image == null" class="font-24 white--text">
                                                {{ user.userName != null ? user.userName.trim().substring(0, 1).toLocaleUpperCase() : ''}}
                                            </span>
                                        </v-avatar>
                                    </v-flex>
                                    <v-flex xs3 lg3>
                                        {{ user.nickName }}
                                    </v-flex>
                                    <v-flex xs2 lg2>
                                        {{ user.iobPower.toFixed(2)|NumFormat }}
                                    </v-flex>
                                    <v-flex xs2 lg2>
                                        {{ user.iobTokens.toFixed(2)|NumFormat }}
                                    </v-flex>
                                    <v-flex xs2 lg2>
                                        {{ user.reputationScore }}
                                    </v-flex>
                                </v-layout>
                                <v-divider v-show="false"></v-divider>
                            </template>
                        </v-card>
                        <infinite-loading :identifier="infiniteId" @infinite="getUserRanking" class="mt-5 mb-5 fw-400">
                            <div slot="spinner">
                                <v-progress-circular indeterminate color="primary"></v-progress-circular>
                            </div>
                            <div slot="no-more">{{$t("posting.noMore")}}</div>
                            <div slot="no-results">{{$t("posting.noResults")}}</div>
                        </infinite-loading>
                    </v-flex>
                </v-layout>
            </v-container>
        </div>
	</div>
</template>
<style>

</style>
<script>
	import Vue from 'vue'
    import config from '../../config.js'
    import InfiniteLoading from 'vue-infinite-loading';
    export default {
        data(){
            return{
                userInfoList: [],
                pageNo: 0,
                infiniteId: +new Date(),
                isLoadingUserInfoList: false
            }
        },
        components: {
            InfiniteLoading,
        },
        created(){
            // 数字格式化
            Vue.filter('NumFormat', function(value) {
                if(!value) return '0.00';
                var intPart = Number(value).toFixed(0); //获取整数部分
                intPart = intPart > value ? intPart - 1 : intPart; // 若四舍五入进了1则减去1
                var intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,'); //将整数部分逢三一断
                var floatPart = ".00"; //预定义小数部分
                var value2Array = value.split(".");
                //=2表示数据有小数位
                if(value2Array.length == 2) {
                    floatPart = value2Array[1].toString(); //拿到小数部分
                    if(floatPart.length == 1) { //补0,实际上用不着
                        return intPartFormat + "." + floatPart + '0';
                    } else {
                        return intPartFormat + "." + floatPart;
                    }
                } else {
                    return intPartFormat + floatPart;
                }
            })
        },
        mounted(){

        },
        watch:{
            
        },
        methods: {
            getUserRanking($state){
                if (this.isLoadingUserInfoList) {
                    return;
                }
                this.isLoadingUserInfoList = true;
                let api = config.baseUrl + 'userDetail/open/getUserRanking?sortField=iobPower&pageNo=' + this.pageNo + '&pageSize=10';
                this.$http.get(api).then( response => {
                    let data = response.data;
                    if (data.resCode == 0) {
                        this.userInfoList = [...this.userInfoList, ...data.result];
                        this.pageNo += 1;
                        this.isLoadingUserInfoList = false;
                        $state.loaded();
                    } else {
                        this.isLoadingUserInfoList = false;
                        $state.complete();
                    }
                });
            },
            //路由到用户主页
            gotoUserData(username){
                this.$router.push({name:'userData', params: {username: '@' + username}})
            },
        },
    }
</script>


// WEBPACK FOOTER //
// UserRanking.vue?2320d583